import { useState, useEffect } from 'react'

/**
 * Subscribes to any Coveo controller and returns a reactive snapshot of its state.
 *
 * Replaces the pattern of paired useState + controller.subscribe calls across
 * SearchContext, allowing each controller's state to be tracked with one line.
 *
 * @param {object} controller - Any Coveo controller with `.state` and `.subscribe()`
 * @returns {object} - A reactive copy of controller.state
 */
export function useControllerState(controller) {
  const [state, setState] = useState(controller.state)
  useEffect(() => {
    // Sync in case state changed between initial render and effect
    setState(controller.state)
    return controller.subscribe(() => setState(controller.state))
  }, [controller])
  return state
}
